import React from "react";

import { useLocation } from "react-router-dom";

import { Container } from "@mui/material";
import Typography from "@mui/material/Typography";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import Grid from "@mui/material/Grid2";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";

import { Root, classes } from "./style";
import { BackButton } from "../backButton";

const pathToNameMapping = {
  quiz: "The Career Safari",
  results: "Results",
  animals: "Meet The Animals",
};

const Breadcrumb = () => {
  const { pathname } = useLocation();
  const current = pathname.split("/").filter((crumb) => crumb !== "")[0];

  return (
    <Root className={classes.banner}>
      <Container className={classes.container}>
        <Grid sx={{ display: "flex" }}>
          {current && <BackButton />}
          <Breadcrumbs
            className={classes.breadcrumb}
            sx={{ marginLeft: current ? "20px" : 0 }}
            separator={<NavigateNextIcon fontSize="small" />}
          >
            <Typography sx={{ fontWeight: 450 }}>
              {current ? pathToNameMapping[current] : "Introduction"}
            </Typography>
          </Breadcrumbs>
        </Grid>
      </Container>
    </Root>
  );
};

export default Breadcrumb;
